export const ACTION_EDIT = 'ACTION_EDIT'
export const GOAL_ACTIONS = 'GOAL_ACTIONS'
export const GOAL_EDIT = 'GOAL_EDIT'
export const GOAL_RATINGS = 'GOAL_RATINGS'
export const MEETING_DETAILS = 'MEETING_DETAILS'
export const STORY_FILTER = 'STORY_FILTER'